module.exports = __webpack_public_path__ + "static/media/fly0184.c80dae0b.webp";